import { FC, useCallback, useMemo, useState } from 'react';
import { useIsDesktop } from '../../hooks/useIsDeskTop';
import { ScrollView, Switch, Text, View } from 'react-native';
import { MAX_WIDTH } from '../../constants/platform';
import MyAccountMenu from '../../components/MyAccountMenu/MyAccountMenu';
import PageTitle from '../../components/PageTitle';
import { COLORS, FONTS } from '../../constants';
import { STYLE_VARS } from '../../constants/style-vars';
import { Footer } from '../../components/Footer';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../services/redux';
import { AuthApi } from '../../services/api/auth.api';
import { setUserInfo } from '../../services/redux/reducers/AuthSlice';
import { Alert } from '../../services/alert';
import { Loading } from '../../components';

const PushNotification: FC = () => {
  const isDesktop = useIsDesktop();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { user } = useSelector((redux: RootState) => redux.authReducer);

  const switchNoti = useCallback(
    async (noti: boolean) => {
      setIsLoading(true);
      AuthApi.updateProfile({
        is_notify: noti ? true : false,
      })
        .then((res) => {
          dispatch(setUserInfo(res.data.data));
        })
        .catch((error) => {
          Alert.alert('Error', error.meta.message);
        })
        .finally(() => {
          setIsLoading(false);
        });
    },
    [dispatch]
  );

  const renderNotificationContent = useMemo(() => {
    return (
      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Text
          style={{
            fontFamily: FONTS.AvenirMedium,
            fontWeight: '800',
            fontSize: 19,
            color: COLORS.LIGHT_BLACK,
            marginRight: 20,
          }}
        >
          Do you want to receive web push notifications?
        </Text>
        <Switch
          trackColor={{
            true: '#34C759',
            false: STYLE_VARS.fccDarkGrey,
          }}
          ios_backgroundColor={STYLE_VARS.fccLightGrey}
          thumbColor={COLORS.WHITE}
          onValueChange={(value: boolean) => {
            switchNoti(value);
          }}
          value={user?.is_notify}
        />
      </View>
    );
  }, [user?.is_notify, switchNoti]);

  if (isDesktop()) {
    return (
      <ScrollView showsVerticalScrollIndicator={false}>
        <View
          style={{
            maxWidth: MAX_WIDTH,
            width: '90%',
            marginHorizontal: 'auto',
            paddingTop: 40,
            marginBottom: 40,
          }}
        >
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'flex-start',
              justifyContent: 'space-between',
            }}
          >
            <View style={{ width: '22%', minWidth: 230, marginRight: 20 }}>
              <MyAccountMenu />
            </View>
            <View style={{ width: '70%' }}>
              <PageTitle title="Push Notifications" haveGoBackButton />
              <View
                style={{
                  paddingHorizontal: 40,
                  paddingTop: 40,
                  backgroundColor: COLORS.LIGHT_RED,
                  borderRadius: 18,
                  flexDirection: 'column',
                  shadowColor: '#F0F0F0',
                  shadowOffset: { width: 0, height: 12 },
                  shadowOpacity: 1,
                  shadowRadius: 32,
                  elevation: 20,
                  paddingBottom: 5,
                  height: 650,
                }}
              >
                {renderNotificationContent}
              </View>
            </View>
          </View>
        </View>
        <Footer />
        {isLoading && <Loading isFullScreen />}
      </ScrollView>
    );
  }

  return (
    <ScrollView showsVerticalScrollIndicator={false}>
      <PageTitle title={'LANGUAGE'} haveGoBackButton={true} />
      <View
        style={{
          paddingHorizontal: 30,
          paddingVertical: 30,
          backgroundColor: COLORS.LIGHT_RED,
          height: 800,
        }}
      >
        {renderNotificationContent}
      </View>
      <Footer />
      {isLoading && <Loading isFullScreen />}
    </ScrollView>
  );
};

export default PushNotification;
